import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { brandPrimary, inputBorderColor } from '../../../web/styles/colors';
import { CssSelectors, FontFamilies } from '../../../web/styles/styles';
import { white } from '../../styles/colors';
import { aidaBaseStyles } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	close: {
		color: white,
		opacity: 1,
	},
	header: {
		...aidaBaseStyles.flexCenter,
		paddingBottom: 25,
		position: 'relative',
	},
	leadCard: {
		marginBottom: 20,
	},
	noResults: {
		color: '#fff',
		textAlign: 'center',
	},
	placeholder: {
		textAlign: 'center',
	},
	placeholderImage: {
		marginTop: 50,
		width: 600,
	},
	resultsContainer: {
		minHeight: 120,
		marginTop: 20,
		paddingTop: 16,
		position: 'relative',
		overflowY: 'auto',
	},
	searchRow: {
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	backdrop: {
		backDropFilter: 'none',
		backgroundColor: 'rgba(4, 108, 182, 0.85)',
	},
	dialogPopup: {
		backgroundColor: 'transparent',
		border: 'none',
		boxShadow: 'none',
		padding: 24,
		left: '50%',
		top: 0,
		translate: '-50% 0',
		maxWidth: 1040,
		height: '100%',
	},
	searchGroup: {
		display: 'flex',
		borderRadius: THEME.common.borderRadius,
		border: `1px solid ${inputBorderColor}`,
		width: '100%',
		backgroundColor: 'white',
		// apply shadow when input inside is focused
		':has(input:focus-visible)': {
			boxShadow: `#F2F2F280 0px 0px 0px 2px`,
			border: `1px solid ${brandPrimary}`,
		},
		// apply shadow when select inside is open
		':has([data-slot="select-trigger"][data-state="open"])': {
			boxShadow: `#F2F2F280 0px 0px 0px 2px`,
			border: `1px solid ${brandPrimary}`,
		},
		// apply shadow when select inside is focused
		':has([data-slot="select-trigger"]:focus-visible)': {
			boxShadow: `#F2F2F280 0px 0px 0px 2px`,
			border: `1px solid ${brandPrimary}`,
		},
	},
	searchSelect: {
		width: 128,
		borderRadius: 0,
		border: 'none',
		borderRight: `1px solid ${inputBorderColor}`,
		height: 'auto',
	},
	searchInput: {
		height: 42,
		flex: 1,
		borderRadius: 'inherit',
		border: 'none',
	},
	searchModal: {
		alignItems: 'flex-start',
		...CssSelectors.allChildren(
			{
				background: 'none',
				border: 'none',
				boxShadow: 'none',
				marginTop: 20,
				maxWidth: '1040px',
				width: '80vw',
			},
			'.modal-overlay-content'
		),
	},
	smallTitle: {
		fontSize: '35px',
		textAlign: 'center',
	},
	title: {
		color: '#fff',
		fontFamily: FontFamilies.conqueror,
		fontSize: '54px',
		textTransform: 'uppercase',
	},
});
